import { BRAILLER_REPLACEMENT_STATUS } from '../braillerConstants';

export const braillerRepairRequestModel = () => ({
    issue: "",
    replacementPreference: BRAILLER_REPLACEMENT_STATUS.NotNeeded.id,
    serialNumber: "",
    noSerialNumber: false,
    shippingLocationId: "",
});

export const createBraillerRepairRequest = (braillerCatalogItemId: string, issue: string = "", reportedBy: string = "", serialNumber: string = "", studentId: string | null = null, replacementPreference: number | null = null, noSerialNumber: boolean = false, braillerLoanId: string | null = null, shippingLocationId: string | null = null) => ({
    braillerCatalogItemId,
    braillerLoanId,
    studentId,
    serialNumber,
    issue,
    reportedBy,
    replacementPreference,
    noSerialNumber,
    shippingLocationId
});